import { z } from 'zod'

let syllabusItemSchema = z.object({
  id: z.string().optional(),
  text: z.string().nonempty('Text is required'),
})

export let coreInfoSchema = z.object({
  linkedServiceID: z.string().nonempty('Linked service is required'),
  sectionID: z.string().nonempty('Category is required'),
  title: z
    .string()
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title must be less than 200 characters'),
  length: z.number().min(0, 'Duration must be 0 or greater'),
  templateID: z.string().nonempty('Template is required'),
})

export let syllabusSchema = z.object({
  description: z.string().nonempty('Description is required'),
  objectives: z.array(syllabusItemSchema),
  references: z.array(syllabusItemSchema),
})

export let courseFormSchema = z.object({
  title: z
    .string()
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title must be less than 200 characters'),
  linkedServiceID: z.string().nonempty('Linked service is required'),
  sectionID: z.string().nonempty('Category is required'),
  templateID: z.string().nonempty('Template is required'),
  length: z.number().min(0, 'Duration must be 0 or greater'),
  banner: z.string(),
  thumbnail: z.string(),
  description: z.string(),
  objectives: z.array(syllabusItemSchema),
  references: z.array(syllabusItemSchema),
})

export let createTemplateFormSchema = z.object({
  name: z.string().nonempty('Template name is required'),
  statement1: z.string().nonempty('Statement is required'),
})

export let createVideoFormSchema = z.object({
  name: z.string().nonempty('Video name is required'),
  description: z.string().nonempty('Description is required'),
})

export let createShowNotesFormSchema = z.object({
  name: z.string().nonempty('Show notes name is required'),
  description: z.string(),
})

export let createQuizFormSchema = z.object({
  name: z.string().nonempty('Quiz name is required'),
})

export let createCategoryFormSchema = z.object({
  name: z.string().nonempty('Category name is required'),
  description: z.string(),
  pageRank: z.number().min(0, 'Page rank must be 0 or greater'),
})
